import {
  ADMIN_USER_ROLE,
  MANAGER_USER_ROLE,
  USER_STATUS_CODE_ACTIVE,
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_INVITED,
} from '../../../../constants/user'

const FULL_STAFF_PERMISSIONS = {
  can_block_user: true,
  can_create_request: true,
  can_delete: true,
  can_edit_files: true,
  can_restore: true,
  can_send_invite: true,
  can_unblock_user: true,
  can_view_files: true,
}

const BASE_STAFF_MOCK = {
  directory_id: 'mock-directory-id',
  id: 9999998,
  isArchived: false,
  isStaff: true,
  permissions: FULL_STAFF_PERMISSIONS,
  role: ADMIN_USER_ROLE,
}

export const PROFILE_ACTIONS_WIDGET_USER_STAFF_VARIANTS = [
  {
    label: 'Actions widget, admin — Online (active)',
    staffData: {
      ...BASE_STAFF_MOCK,
      fullname: 'Monica Becker',
      status: USER_STATUS_CODE_ACTIVE,
    },
  },
  {
    label: 'Actions widget, manager — Invited',
    staffData: {
      ...BASE_STAFF_MOCK,
      fullname: 'John Sachs',
      role: MANAGER_USER_ROLE,
      status: USER_STATUS_CODE_INVITED,
    },
  },
  {
    label: 'Actions widget, admin — Blocked',
    staffData: {
      ...BASE_STAFF_MOCK,
      fullname: 'Monica Becker',
      status: USER_STATUS_CODE_BLOCKED,
    },
  },
  {
    label: 'Actions widget, admin — archived',
    staffData: {
      ...BASE_STAFF_MOCK,
      fullname: 'Monica Becker',
      isArchived: true,
      status: USER_STATUS_CODE_BLOCKED,
    },
  },
]
